import { Target, LandPlot, Trophy, CircleDollarSign } from 'lucide-react';
import { IconBox } from '@/ui/primitives';
import { useMetricas } from '../api';

// Caixas de destaque com largura FIXA (191px, mesma dos cards do relatório de
// Operações de Crédito) — não esticam pra preencher a tela. Ícone em chip coral,
// valor neutro (coral só no chip). PageShell já envolve children em px-8.
export function CrmStats() {
  const { data } = useMetricas();
  const ativos = data?.ativos_por_frente.reduce((s, f) => s + Number(f.qtd ?? 0), 0) ?? 0;
  const ganhos = data?.ganhos?.qtd ?? 0;
  const valorGanho = data?.ganhos?.valor ?? 0;
  // Hectares = carteira total (SUM de todos os imóveis), mesmo cálculo do
  // Dashboard. NÃO usar area_ativa_ha: ela soma via JOIN em crm_oportunidade
  // e conta o mesmo imóvel N vezes quando ele tem >1 oportunidade ativa.
  const hectares = data?.area_carteira_ha ?? 0;

  const fmtBRL = (v: number) =>
    v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

  // Card compacto do CRM (Figma 4848:485): ~92x77, menor que o Stat padrao.
  // O Stat fixa label 11px / valor 20px; aqui precisamos menor, entao card
  // proprio reusando o IconBox coral (size sm = 28px, igual ao Figma).
  const Destaque = ({ Icon, label, value }: { Icon: typeof Target; label: string; value: string }) => (
    <div className="flex w-[92px] flex-col gap-2 rounded-[12px] border border-border bg-surface p-2.5 dark:border-0 dark:bg-surface2">
      <IconBox size="sm" tone="solid" className="rounded-[9px]">
        <Icon size={14} strokeWidth={1.7} />
      </IconBox>
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="text-[8px] font-medium uppercase leading-tight tracking-wide text-text-muted">
          {label}
        </span>
        <span className="text-[15px] font-semibold leading-tight tracking-tight text-text tabular-nums">
          {value}
        </span>
      </div>
    </div>
  );

  return (
    <div className="pb-2">
      <div className="flex flex-wrap gap-3">
        <Destaque Icon={Target} label="Oportunidades" value={String(ativos)} />
        {/* sem " ha": o rotulo ja diz Hectares e no card estreito o sufixo quebraria */}
        <Destaque
          Icon={LandPlot}
          label="Hectares"
          value={hectares.toLocaleString('pt-BR', { maximumFractionDigits: 0 })}
        />
        <Destaque Icon={Trophy} label="Ganhos" value={String(ganhos)} />
        <Destaque Icon={CircleDollarSign} label="Valor fechado" value={fmtBRL(valorGanho)} />
      </div>
    </div>
  );
}
